import React from 'react'
import cn from 'classnames'
import PropTypes from 'prop-types'

const LinkButton = ({ className, onClick, children, title, href = '#root', ...rest }) => {
  const handleClick = event => {
    if (onClick) {
      event.preventDefault()
      onClick(event)
    }
  }

  return (
    <a className={cn(['btn', '-link', className])} href={href} onClick={handleClick} {...rest}>
      {children || title}
    </a>
  )
}

LinkButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string,
  href: PropTypes.string,
  children: PropTypes.string,
}

export default LinkButton
